import { plainToInstance } from 'class-transformer';
import { AbstractNetworkService } from 'core/data/remote/AbstractNetworkService';
import { NetWorkService } from 'core/data/remote/NetworkService';
import { ResponseResult } from 'core/models/ResponseResult';
import { SewingModel } from 'features/sewing/data/models/SewingModel';
import { AbstractSewingRemoteDataSource } from 'features/sewing/data/remote/Abstract_sewing_remote_data_source';
export class SewingRemoteDataSource implements AbstractSewingRemoteDataSource {
  netowkService: AbstractNetworkService = new NetWorkService();
  async getSewingCeremonyDressData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/sewing_ceremony_dress_get_data');
      response.data = this.convertFromJsonToTableModel(response.data);
      return response;
    } catch (error) {
      return this.defaultError();
    }
  }
  async getSewingCurtainsData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/sewing_curtains_get_data');
      response.data = this.convertFromJsonToTableModel(response.data);
      return response;
    } catch (error) {
      return this.defaultError();
    }
  }
  async getSewingJacketsData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/sewing_jackets_get_data');
      response.data = this.convertFromJsonToTableModel(response.data);
      return response;
    } catch (error) {
      return this.defaultError();
    }
  }
  async getSewingJeansData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/sewing_jeans_get_data');
      response.data = this.convertFromJsonToTableModel(response.data);
      return response;
    } catch (error) {
      return this.defaultError();
    }
  }
  async getSewingKnitwearBlousesShirtsPoloData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/sewing_knitwear_blouses_shirts_polos_get_data');
      response.data = this.convertFromJsonToTableModel(response.data);
      return response;
    } catch (error) {
      return this.defaultError();
    }
  }
  async getSewingLiningsData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/sewing_linings_get_data');
      response.data = this.convertFromJsonToTableModel(response.data);
      return response;
    } catch (error) {
      return this.defaultError();
    }
  }
  async getSewingMenCoatsData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/sewing_men_coats_get_data');
      response.data = this.convertFromJsonToTableModel(response.data);
      return response;
    } catch (error) {
      return this.defaultError();
    }
  }
  async getSewingMenPantsData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/sewing_men_pants_get_data');
      response.data = this.convertFromJsonToTableModel(response.data);
      return response;
    } catch (error) {
      return this.defaultError();
    }
  }
  async getSewingMenShirtsData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/sewing_men_shirts_get_data');
      response.data = this.convertFromJsonToTableModel(response.data);
      return response;
    } catch (error) {
      return this.defaultError();
    }
  }
  async getSewingSkirtsData(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/sewing_skirts_get_data');
      response.data = this.convertFromJsonToTableModel(response.data);
      return response;
    } catch (error) {
      return this.defaultError();
    }
  }
  defaultError(): ResponseResult {
    return new ResponseResult({
      code: '0',
      timeStamp: new Date().toISOString(),
      success: false,
      message: 'Unknown Error - An undefined error occured',
      data: null,
    });
  }

  convertFromJsonToTableModel(data: any): SewingModel[] {
    return (data as []).flatMap((e) => plainToInstance(SewingModel, e));
  }
}
